import range from 'lodash-es/range'
import * as React from 'react'

import { IEnhancedLocation } from '../../../../../common/reducers/reactRouterLocation'
import { IDecoratedItem } from '../../../../../typings/searchResults'
import ItemCard from '../../itemCard'
import { IItemsListing } from '../index'

import * as styles from './default.module.css'

interface IProps extends IDecoratedItem {
  location: IEnhancedLocation
}

const Default = ({ items, itemDecorator }: IItemsListing) => {
  return (
    <ul className={styles.root}>
      {items.map((item, index) => {
        const itemProps = itemDecorator(item, index) as IProps
        return <ItemCard {...itemProps} key={item.id} />
      })}
      {range(3).map(item => (
        <li
          key={`empty${item}`}
          role="presentation"
          aria-hidden="true"
          className={styles.emptyItem}
        />
      ))}
    </ul>
  )
}
export default Default
